<div class="orders-table" data-test="orders-table">
  <div class="notification notification-info text--small">
    <mat-icon>info</mat-icon>
    {{ 'app.orders.description-sap' | translate }}
  </div>

  <div class="orders-table__table spacing--margin-top">
    <agr-table
      *ngIf="tableConfig"
      [emptyTitle]="'app.orders-table.error-messages.empty-title' | translate"
      [emptyDescription]="'app.orders-table.error-messages.empty-description' | translate"
      [config]="tableConfig"
      data-test="orders-table__table"
    >
    </agr-table>
  </div>

  <ng-template #orderNumbersColumn let-row="row">
    <span>{{ row.orderNumbers | join: ', ' }}</span>
  </ng-template>

  <ng-template #orderTypeColumn let-row="row">
    <span>{{ 'app.order-types.' + row.orderType | lowercase | translate }}</span>
  </ng-template>

  <ng-template #createdOnColumn let-row="row">
    <span>{{ row.createdOn | agrDate: 'short' }}</span>
  </ng-template>

  <ng-template #orderNrOfProducts let-row="row">
    <span>{{ row.numberOfProducts }}</span>
  </ng-template>

  <ng-template #orderStatusColumn let-row="row">
    <div *ngIf="row.orderStatus !== orderStatusType.Error" data-test="orders-table__status">
      {{ 'app.orders.status-' + row.orderStatus | translate }}
    </div>
    <div
      *ngIf="row.orderStatus === orderStatusType.Error"
      matTooltip="{{ 'app.orders.status-error-tooltip' | translate }}"
      class="flex--row flex--align-center text-color--warn"
      data-test="orders-table__error-status"
    >
      <span class="">{{ 'app.orders.status-' + row.orderStatus | translate }}</span>
      <mat-icon class="spacing--margin-half-left">info_outline</mat-icon>
    </div>
  </ng-template>
</div>
